<pms-container [load]="loadFn" (data)="onData($event)">
  <snoots-page-generic *containerContent [noPadding]="true" [noMargin]="true">
    <div class="flex flex-1 flex-col gap-0">
      <snt-report-designer
        [previewVisible]="true"
        [readonly]="!!soapTemplate?.published"
        [defaultItems]="defaultItems"
        [headerHTML]="headerHTML"
        [footerHTML]="footerHTML"
        [tablePropertyDataSource]="tablePropertyDataSource"
        (templateConfigChange)="onTemplateConfigChange($event)"
        (rawTemplateConfigChange)="onRawTemplateConfigChange($event)"
      ></snt-report-designer>

      <div class="bg-white flex flex-row justify-end gap-4 p-2">
        <div class="flex flex-row gap-2">
          @if (!soapTemplate?.published) {
            <div class="rounded-md bg-orange-400 p-2 shadow-md select-none">
              <span class="text-sm text-white">{{ "BOZZA" | transloco }}</span>
            </div>
          }

          @if (soapTemplate?.published) {
            <div class="rounded-md bg-green-400 p-2 shadow-md select-none">
              <span class="text-sm text-white">{{
                "PUBBLICATO" | transloco
              }}</span>
            </div>
          }
        </div>

        <div class="flex flex-row gap-2">
          @if (!soapTemplate?.published) {
            <snt-button
              [title]="'Annulla' | transloco"
              (onClickAsync)="onCancel($event)"
            ></snt-button>
          }

          @if (!soapTemplate?.published) {
            <snt-button
              [title]="'Salva e chiudi' | transloco"
              (onClickAsync)="onClose($event)"
            ></snt-button>
          }

          @if (soapTemplate?.published) {
            <snt-button
              [title]="'Chiudi' | transloco"
              (onClickAsync)="onClose($event)"
            ></snt-button>
          }

          <snt-button
            [disabled]="!!soapTemplate?.published"
            [title]="'Salva e pubblica' | transloco"
            type="primary"
            (onClickAsync)="onPublish($event)"
          ></snt-button>
        </div>
      </div>
    </div>
  </snoots-page-generic>
</pms-container>
